/**
 * Javascript for hiding the marketing content on Brexit restricted pages.
 */
(function(window, document, $, undefined) {
	"use strict";

	// Only run on Brexit restricted products
	if ( $( '.brexit-restrict' ).length ) {
		// Move the required elements out of .fl-builder-content so they become visible again.
		$( $( ".investment-objective-heading, .fl-module-investment-objective, .investmentObjectiveBottom" ).detach() ).appendTo( ".entry-content" );
		// Go ahead and complete remove .fl-builder-content from the DOM now
		$( '.fl-builder-content' ).remove();
	}

})( window, document, jQuery );
